import { useQuery } from "@origin-digital/query";
import { IArticleDataResponse } from "../contract";
import { fetchArticle } from "../services/articles";
import { toError, useShouldThrowQueryError } from "./useShouldThrowQueryError";

export interface UseArticleResult {
  data: IArticleDataResponse | null;
  loading: boolean;
  error: Error | null;
}

export const useArticle = (slug: string | undefined): UseArticleResult => {
  const { data, error, isLoading } = useQuery({
    queryKey: ["article", slug],
    queryFn: () => {
      if (!slug) {
        throw new Error("Article slug is required");
      }
      return fetchArticle({ slug });
    },
    staleTime: 0,
    enabled: Boolean(slug),
  });

  const articleError = toError(error);
  useShouldThrowQueryError(articleError, {
    component: "useArticle",
    action: "fetchArticle",
  });

  return {
    data: data ?? null,
    loading: isLoading,
    error: articleError,
  };
};
